import axios from 'axios';

import config from '../common/config';

export default {
  fetchSerchAttractionsByRide(token, rideId, lat, lng) {
    return axios.get(`${config.config.ROOT_URL}/serch_attractions_by_location_api/${rideId}/${lat}/${lng}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  fetchSerchAttractionsFromRideMangerAcount(token, rideId, lat, lng, filters = {}) {
    const headers = {
      Authorization: `Bearer ${token}`
    };
    if (Object.keys(filters).length > 0) {
      headers.Data = JSON.stringify(filters);
    }
    return axios.get(`${config.config.ROOT_URL}/serch_attractions_of_ride_manger_by_location_api/${rideId}/${lat}/${lng}`, {
      headers
    });
  },
  fetchSerchActivityByRideFromGoogle(token, rideId, lat, lng, serchType) {
    return axios.get(`${config.config.ROOT_URL}/serch_activity_by_location_with_google_api/${rideId}/${lat}/${lng}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Data: serchType
      }
    });
  },
  fetchRideMangerAttractions(token) {
    return axios.get(`${config.config.ROOT_URL}/fetch_ride_manager_attractions`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },

};
